import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { UserContextProvider } from './context/userContext';
import PrivateRouteLayout from './pages/PrivateRouteLayout/PrivateRouteLayout';
import ViewPage from './pages/View/ViewPage';
import LoginPage from './pages/Login/LoginPage';
import CreateUserPage from './pages/CreateUser/CreateUserPage';
import SpotfireOAuth from './pages/SpotfireOAuth/SpotfireOAuth';
import ResetPasswordPage from './pages/ResetPassword/ResetPasswordPage';
import AdminPage from './pages/Admin/AdminPage';
import PasswordExpiredPage from './pages/PasswordExpired/PasswordExpiredPage';
import ManageRegistrationPage from './pages/ManageRegistration/ManageRegistrationPage';
import { ManageRegistrationMode } from './types/appTypes';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import ADSignIn from './pages/ADSignIn/ADSignIn';
import HomePage from './pages/Home/HomePage';
import DocumentsStorePage from './pages/DocumentStore/DocumentStorePage';
import { ThemeProvider } from './context/themeContext';
import AccountPage from './pages/Account/AccountPage';

type AppProps = {
  msalApp: PublicClientApplication;
};

function App({ msalApp }: AppProps) {
  return (
    <MsalProvider instance={msalApp}>
      <UserContextProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path='/login' element={<LoginPage />} />
              <Route path='/register' element={<CreateUserPage />} />
              <Route path='/resetpassword' element={<ResetPasswordPage />} />
              <Route path='/sfoauth' element={<SpotfireOAuth />} />
              <Route path='/adsignin' element={<ADSignIn />} />
              <Route path='/account' element={<AccountPage />} />
              
              <Route element={<PrivateRouteLayout requiredRole='Any' />}>
                <Route path='/' element={<HomePage />} />
                <Route path='/view' element={<ViewPage />} />
              </Route>

              <Route element={<PrivateRouteLayout requiredRole='Expired' />}>
                <Route
                  path='/passwordExpired'
                  element={<PasswordExpiredPage />}
                />
              </Route>

              <Route
                element={
                  <PrivateRouteLayout requiredRole='Admin,atlas.admin,Manager,atlas.manager,User,atlas.user' />
                }
              >
                <Route path='/documentstore/*' element={<DocumentsStorePage />} />
              </Route>

              <Route
                element={
                  <PrivateRouteLayout requiredRole='Admin,atlas.admin,Manager,atlas.manager' />
                }
              >
                <Route
                  path='/approve'
                  element={
                    <ManageRegistrationPage
                      mode={ManageRegistrationMode.Approval}
                    />
                  }
                />
              </Route>

              <Route
                element={<PrivateRouteLayout requiredRole='Admin,atlas.admin' />}
              >
                <Route path='/admin' element={<AdminPage />} />
                <Route
                  path='/admin/createRegistration'
                  element={
                    <ManageRegistrationPage
                      mode={ManageRegistrationMode.Create}
                    />
                  }
                />
                <Route
                  path='/admin/manageUser'
                  element={
                    <ManageRegistrationPage
                      mode={ManageRegistrationMode.EditAtlas}
                    />
                  }
                />
                <Route
                  path='/admin/manageKey'
                  element={
                    <ManageRegistrationPage
                      mode={ManageRegistrationMode.EditApi}
                    />
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </UserContextProvider>
    </MsalProvider>
  );
}

export default App;
